var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 421.789,
    height: 257.172,
    viewBox: "0 0 421.789 257.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 42.896,
    height: 25.961,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-1319.333 -760.732)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M2026.141-239.544c-329.4-10.357-406.432-229.348-406.432-229.348",
    transform: "translate(-294 1236)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(1715.161 1017.904) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M4.978,0A13.757,13.757,0,0,1,7.831,1.8Q14.115,7.876,20.2,14.153c1.064,1.095,1.678,1.058,2.722-.015C27.07,9.88,31.306,5.71,35.512,1.511A4.237,4.237,0,0,1,40.043.259,3.624,3.624,0,0,1,42.9,3.543a5.949,5.949,0,0,1-1.189,3.868C36.141,13.227,30.42,18.9,24.7,24.561a4.1,4.1,0,0,1-6.13.044Q9.888,16.079,1.331,7.433a4.079,4.079,0,0,1-.876-4.9C1.187.965,2.51.139,4.978,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8414a39438625daaf9afcf79578fd87a.svg";
export { ForwardRef as ReactComponent };